// Enums and Interface
import { ControlType, Field, FormComponentType, Layout } from '../../../models/common/forms/form-field-config';

// Constants
import { BUSINESS_REWARD_CONSTANT } from '../../translate-messages/form-control/auth';

/**
 * Constant For the BusinessRewardControl
 */
export const labelManage: Field = {

  key: 'client',
  type: ControlType.TEXT,
  component: FormComponentType.TEXTBOX,
  templateOptions: {
    layout: Layout.VERTICAL,
    label: 'Client',
    placeholder: 'Client',
    tooltip:`Change 'Client' to fit your business, like 'Customer', 'Agency', or any preferred term.` ,
    tooltipPosition:'right',
    disabled: false,
  },
  validations: {
    validators: {
      required: true,
      max_length: 50,
      min_length:3,
      pattern : /^[\w\s]*$/
    },
    messages: {
    },
  },
  classNames: {
    main: 'col-xl-6 col-lg-12',
  },
};
